<template>
<!-- 本地图文 -->
  <div class="LogoCrawlList">
    <el-tabs class="nativeBox" v-model="activeName">
      <!-- logo -->
      <el-tab-pane :label="$t('lang.logo')" name="logo">
        <selectLogo
        v-if="activeName == 'logo'"
        :fixedDevice="fixedDevice"
        :nativeInfo="nativeInfo"
        @ShowUsageDetails="ShowUsageDetails"
        ></selectLogo>
      </el-tab-pane>
      <!-- crawl -->
      <el-tab-pane :label="$t('lang.Crawl')" name="crawl">
        <crawl :nativeInfo="nativeInfo" v-if="activeName == 'crawl'" @ShowUsageDetails="ShowUsageDetails"></crawl>
      </el-tab-pane>
    </el-tabs>
    <logo-crawl-delete-hint v-if="HintMessageList.switch" :HintMessageList="HintMessageList"></logo-crawl-delete-hint>
  </div>
</template>
<script>
import selectLogo from './selectLogo'
import crawl from './crawl'
import LogoCrawlDeleteHint from '@/components/file/LogoCrawlDeleteHint.vue'
export default {
  components: {
    selectLogo,
    crawl,
    LogoCrawlDeleteHint
  },
  props: {
    fixedDevice: { // 选中图片的信息及位置
      default: null,
      type: Object
    },
    nativeInfo: {
      type: Object,
      default: () => ({
        logoOnFlag: false,
        CrawlOnFlag: false
      })
    }
  },
  data () {
    return {
      activeName: 'logo',
      HintMessageList: {
        switch: false,
        list: {}
      }
    }
  },
  created () {},
  methods: {
    // 显示使用提示详情
    ShowUsageDetails (data) {
      this.HintMessageList = {
        switch: true,
        list: data
      }
    }
  }
}
</script>
<style lang="less" scoped>
.LogoCrawlList{
  height: 100%;
}
.nativeBox {
  height: 100%;
  ::v-deep .el-tabs__header {
    width: 100%;
    margin-bottom: 0;
    .el-tabs__nav-wrap{
      padding: 0;
      span{
        display: none;
      }
      .el-tabs__nav {
        width: 100%;
        display: flex;
        .el-tabs__item{
          height: 32px;
          line-height: 32px;
          padding: 0;
        }
      }
    }
  }
  ::v-deep .el-tabs__content {
    height: calc(100% - 32px);
    overflow: visible;
    .el-tab-pane{
      height: 100%;
    }
  }
  ::v-deep .el-tabs__nav {
      .el-tabs__item.is-top {
        background: #333!important;
        color: #666!important;
        width: 50%!important;
        &.is-active {
          background: #666!important;
          color: #dedede!important;
        }
      }
      .el-tabs__active-bar {
        display: none;
      }
    }
}
</style>
